import React, { useEffect } from 'react';

interface AdSenseLoaderProps {
  clientId?: string;
}

export const AdSenseLoader: React.FC<AdSenseLoaderProps> = ({ clientId = 'ca-pub-4977871913539025' }) => {
  useEffect(() => {
    const triggerAds = () => {
      try {
        // Push for any existing ad slots
        const ins = document.querySelectorAll('ins.adsbygoogle');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const w = window as any;
        if (ins.length && typeof w.adsbygoogle !== 'undefined') {
          for (let i = 0; i < ins.length; i++) {
            try { (w.adsbygoogle = w.adsbygoogle || []).push({}); } catch {}
          }
        }
      } catch {}
    };
    // Avoid duplicate injection
    if (document.querySelector('script[data-adsbygoogle]')) {
      // If script already present (navigated within blog), try to render any pending slots
      triggerAds();
      return () => {
      const existing = document.querySelector('script[data-adsbygoogle]');
      if (existing) existing.parentElement?.removeChild(existing);
      try {
        // Remove global object to prevent reuse outside blog
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete (window as any).adsbygoogle;
      } catch {}
      };
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
    script.crossOrigin = 'anonymous';
    script.setAttribute('data-adsbygoogle', 'true');
    script.addEventListener('load', () => {
      triggerAds();
    });
    document.head.appendChild(script);

    return () => {
      // Remove the script when leaving blog pages
      const injected = document.querySelector('script[data-adsbygoogle]');
      if (injected) injected.parentElement?.removeChild(injected);
      try {
        // Remove global object and queued pushes
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete (window as any).adsbygoogle;
      } catch {}
    };
  }, [clientId]);

  return null;
};

export default AdSenseLoader;


